import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { CrowdstrikeConnector } from '../../connector';

export const CrowdstrikeService = IntegrationService.make({
  connector: CrowdstrikeConnector,
  name: Integration_Service_Names_Enum.Crowdstrike,
});
